export const BUSINESS_TYPES = [
  {
    id: "restaurant",
    icon: "🍽️",
    label: "bt_restaurant",
    taxNote: "bt_restaurant_note",
    rates: "bt_restaurant_rates",
    authority: "bt_provincial",
  },
  {
    id: "retail",
    icon: "🛍️",
    label: "bt_retail",
    taxNote: "bt_retail_note",
    rates: "bt_retail_rates",
    authority: "bt_fbr",
  },
  {
    id: "pharmacy",
    icon: "💊",
    label: "bt_pharmacy",
    taxNote: "bt_pharmacy_note",
    rates: "bt_pharmacy_rates",
    authority: "bt_fbr",
  },
  {
    id: "supermarket",
    icon: "🛒",
    label: "bt_supermarket",
    taxNote: "bt_supermarket_note",
    rates: "bt_supermarket_rates",
    authority: "bt_fbr",
  },
  {
    id: "hotel",
    icon: "🏨",
    label: "bt_hotel",
    taxNote: "bt_hotel_note",
    rates: "bt_hotel_rates",
    authority: "bt_provincial_fbr",
  },
  {
    id: "salon",
    icon: "✂️",
    label: "bt_salon",
    taxNote: "bt_salon_note",
    rates: "bt_salon_rates",
    authority: "bt_provincial",
  },
  {
    id: "electronics",
    icon: "📱",
    label: "bt_electronics",
    taxNote: "bt_electronics_note",
    rates: "bt_electronics_rates",
    authority: "bt_fbr",
  },
  {
    id: "fuel",
    icon: "⛽",
    label: "bt_fuel",
    taxNote: "bt_fuel_note",
    rates: "bt_fuel_rates",
    authority: "bt_fbr",
  },
  {
    id: "telecom",
    icon: "📡",
    label: "bt_telecom",
    taxNote: "bt_telecom_note",
    rates: "bt_telecom_rates",
    authority: "bt_fbr",
  },
  {
    id: "clinic",
    icon: "🏥",
    label: "bt_clinic",
    taxNote: "bt_clinic_note",
    rates: "bt_exempt",
    authority: "bt_fbr_provincial",
  },
  {
    id: "education",
    icon: "🎓",
    label: "bt_education",
    taxNote: "bt_education_note",
    rates: "bt_exempt",
    authority: "bt_provincial",
  },
  {
    id: "other",
    icon: "🏪",
    label: "bt_other",
    taxNote: "bt_other_note",
    rates: "bt_varies",
    authority: "bt_fbr_provincial",
  },
];

export const NAV = [
  { key: "home", label: "nav_home" },
  { key: "upload", label: "nav_scan" },
  { key: "guides", label: "nav_guides" },
  { key: "about", label: "nav_about" },
];

export const TRANSLATIONS = {
  en: {
    nav_home: "Home",
    nav_search: "Search Businesses",
    nav_verify: "Verify NTN / STRN",
    nav_scan: "Scan Receipt",
    nav_guides: "Tax Guides",
    nav_about: "About",
    nav_contact: "Contact",
    nav_privacy: "Privacy",
    nav_terms: "Terms",
    nav_disclaimer: "Disclaimer",
    hero_eyebrow: "Pakistan's Consumer Tax Verification Tool",
    hero_title: "Verify Tax Registration",
    hero_title_em: "For Any Business",
    hero_sub:
      "Before paying GST or service tax on any bill, verify the business is legitimately registered with Pakistan's tax authorities.",
    stat_businesses_label:
      "businesses found in publicly available FBR taxpayer data.",
    scan_receipt: "Scan a Receipt",
    all_business_types: "All Business Types",
    fbr_atl_database: "FBR ATL Database",
    name_ntn_search: "Name & NTN Search",
    receipt_scanner: "Receipt Scanner",
    always_free: "Always Free",
    theme_light: "Light",
    theme_dark: "Dark",
    lang_toggle: "اردو",
    footer_desc:
      "Pakistan's consumer tax verification tool — for restaurants, shops, pharmacies, hotels, and more. Informational only. Always confirm with official authorities.",
    footer_copy:
      "Not affiliated with FBR, SRB, PRA, KPRA, BRA or any government body.",
    search_title: "Search FBR Database",
    search_sub:
      "Look up any business directly against FBR's Active Taxpayer List — by NTN, SNTN, or business name.",
    records_loaded: "records loaded",
    sntn_label: "SNTN — Sindh Sales Tax Number",
    ntn_label: "NTN — National Tax Number",
    search_placeholder: "e.g. 7221683-2  or  S7221683-2  or  7221683",
    try_example: "try an example",
    search_fbr: "Search FBR Database",
    found_in_db: "FOUND IN FBR DATABASE",
    not_found_in_db: "NOT FOUND IN FBR DATABASE",
    business_name_label: "Business / Taxpayer Name",
    name_search_placeholder: "e.g. Hafiz Jee  or  Karachi Foods",
    name_search_hint:
      "Searches both taxpayer name and business name · minimum 2 characters",
    how_search_works: "How the search works",
    disclaimer_text:
      "Informational verification only — does not constitute legal findings. Always confirm with official FBR / provincial authorities.",
    taxpayer_name: "Taxpayer Name",
    business_name: "Business Name",
    atl_status: "ATL Status",
    active: "Active",
    status_registered: "✅ Likely Registered",
    status_partial: "⚠️ Partial / Uncertain",
    status_weak: "🔶 Weak Signals Only",
    status_not_found: "❌ No Valid Signals Found",
    verify_on_srb: "Verify on SRB",
    verify_on_fbr: "Verify on FBR",
    result_note:
      "Score based on FBR database lookup, STRN format, and QR analysis. Always confirm via official portals for legal certainty.",
    supported_business_types: "Supported Business Types",
    tax_rules: "Tax Rules by Business Type",
    official_authorities: "Official Tax Authorities",
    how_title_1: "Search the Database",
    how_text_1:
      "Search {count} registered businesses by NTN, SNTN, or business name directly from FBR's Active Taxpayer List.",
    how_title_2: "Enter Any Format",
    how_text_2:
      "Type NTN (7221683-2), SNTN (S7221683-2), or bare digits (7221683). We handle the stripping and matching automatically.",
    how_title_3: "Scan the Receipt",
    how_text_3:
      "Upload a photo of any bill. We detect FBR POS QR codes and extract NTN/STRN via OCR — for any type of business.",
    how_title_4: "Verify on FBR",
    how_text_4:
      "We deep-link directly to FBR's official portal pre-filled with the numbers — one tap to confirm with the source.",
    business: "Business",
    tax_type: "Tax Type",
    authority: "Authority",
    rate: "Rate",
    business_type: "Business Type",
    tax_authority: "Tax Authority",
    typical_rate: "Typical Rate",
    note: "Note",
    bt_restaurant: "Restaurant / Café",
    bt_restaurant_note:
      "Service tax via provincial authority (SRB/PRA/KPRA). FBR POS mandatory for Tier-1.",
    bt_restaurant_rates: "13–16% service tax",
    bt_retail: "Shopping / Retail Store",
    bt_retail_note:
      "GST on goods sold. Tier-1 retailers must have FBR-integrated POS.",
    bt_retail_rates: "17% GST standard",
    bt_pharmacy: "Pharmacy / Medical Store",
    bt_pharmacy_note:
      "Many medicines are zero-rated or exempt. GST applies to non-exempt items only.",
    bt_pharmacy_rates: "0–17% GST (varies)",
    bt_supermarket: "Supermarket / Grocery",
    bt_supermarket_note:
      "GST on packaged goods. Fresh produce and staples are often zero-rated or exempt.",
    bt_supermarket_rates: "17% GST (packaged items)",
    bt_hotel: "Hotel / Guesthouse",
    bt_hotel_note:
      "Service tax on accommodation. Federal Excise Duty (FED) may also apply on luxury services.",
    bt_hotel_rates: "16% + possible FED",
    bt_salon: "Salon / Spa / Beauty",
    bt_salon_note:
      "Service tax on beauty/grooming services. Smaller salons often below registration threshold.",
    bt_salon_rates: "13–16% service tax",
    bt_electronics: "Electronics Store",
    bt_electronics_note:
      "17% GST standard on electronics. Withholding tax may also apply. Check for FBR POS.",
    bt_electronics_rates: "17% GST",
    bt_fuel: "Petrol Station",
    bt_fuel_note:
      "Petroleum levy and GST apply. POS integration mandatory for major outlets.",
    bt_fuel_rates: "GST + Petroleum Levy",
    bt_telecom: "Telecom / Mobile Shop",
    bt_telecom_note:
      "GST on SIM cards and devices. Service charges subject to service tax.",
    bt_telecom_rates: "17–19.5% GST",
    bt_clinic: "Clinic / Hospital",
    bt_clinic_note:
      "Medical services are generally exempt from GST. Diagnostic labs may be taxable.",
    bt_education: "School / Tuition Centre",
    bt_education_note:
      "Educational services are generally exempt. Commercial coaching centres may be taxable.",
    bt_other: "Other Business",
    bt_other_note:
      "Select the closest category for relevant guidance, or enter NTN/STRN to validate directly.",
    bt_varies: "Varies",
    bt_exempt: "Mostly exempt",
    bt_provincial: "Provincial (SRB/PRA/KPRA/BRA)",
    bt_fbr: "FBR (Federal)",
    bt_provincial_fbr: "Provincial + FBR",
    bt_fbr_provincial: "FBR / Provincial",
    auth_fbr_full: "Federal Board of Revenue",
    auth_srb_full: "Sindh Revenue Board",
    auth_pra_full: "Punjab Revenue Authority",
    auth_kpra_full: "KPK Revenue Authority",
    auth_bra_full: "Balochistan Revenue Auth.",
    region_federal: "Federal",
    region_sindh: "Sindh",
    region_punjab: "Punjab",
    region_kpk: "KPK",
    region_balochistan: "Balochistan",
    about_title: "About TaxVerifypk.com",
    about_p1:
      "TaxVerifypk.com is an independent consumer platform helping Pakistanis verify tax registration across all types of businesses.",
    about_h1: "What We Do",
    about_p2:
      "We match NTN and SNTN numbers directly against FBR's Active Taxpayer List — a database of all registered taxpayers. SNTN (Sindh receipts starting with S) are automatically stripped and looked up. We also detect FBR POS QR codes in receipt images via jsQR and extract registration numbers via Tesseract.js OCR.",
    about_h2: "Check Digit Policy",
    about_p3:
      "We no longer reject NTNs based on check digit mismatch. As confirmed through real-world testing, FBR's own portal ignores the check digit and matches on the 7-digit base. We flag mismatches as likely printing errors but still look up the business in the database.",
    about_h3: "Privacy",
    about_p4:
      "All receipt scanning happens entirely in your browser. Nothing is sent to any server. No data is stored.",
    msg_sent: "Message sent",
    msg_sent_sub: "We'll respond within 2–3 business days.",
    name: "Name",
    full_name: "Full name",
    email: "Email",
    email_placeholder: "your@email.com",
    subject: "Subject",
    sub_1: "Report a suspicious business",
    sub_2: "Data correction",
    sub_3: "General inquiry",
    sub_4: "Media / press",
    sub_5: "Partnership",
    message: "Message",
    message_placeholder: "Your message…",
    send_message: "Send Message",
    karachi_pakistan: "Karachi, Pakistan",
    verify_sub:
      "Check any registration number against FBR's database and get a direct verification link. SNTN (Sindh receipts) are automatically handled.",
    and_or: "and / or",
    sntn_hint:
      "SRB issues SNTNs as S + NTN — e.g. S7221683-2. We strip the S and look up in FBR automatically.",
    upload_title: "Scan Any Business Receipt",
    upload_sub:
      "Upload a photo of any bill. We'll detect QR codes, extract NTN/STRN via OCR, and look up against FBR's database.",
    all_guides: "All Guides",
    guides_sub:
      "Everything you need to know about taxes across all business types in Pakistan — written for consumers, not accountants.",
    search_by_ntn: "Search by NTN / SNTN",
    search_by_name: "Search by Business Name",
    no_matches_found: "No Matches Found",
    no_match_msg: "No businesses found matching \"{query}\" in the FBR database.",
    not_found_msg: "was not found in the FBR Active Taxpayer List.",
  },
  ur: {
    nav_home: "ہوم",
    nav_search: "کاروبار تلاش کریں",
    nav_verify: "NTN / STRN کی تصدیق کریں",
    nav_scan: "رسید اسکین کریں",
    nav_guides: "ٹیکس گائیڈز",
    nav_about: "ہمارے بارے میں",
    nav_contact: "رابطہ",
    nav_privacy: "پرائیویسی",
    nav_terms: "شرائط",
    nav_disclaimer: "دستبرداری",
    hero_eyebrow: "پاکستان کا کنزیومر ٹیکس ویریفیکیشن ٹول",
    hero_title: "ٹیکس رجسٹریشن کی تصدیق کریں",
    hero_title_em: "کسی بھی کاروبار کے لیے",
    hero_sub:
      "کسی بھی بل پر جی ایس ٹی یا سروس ٹیکس ادا کرنے سے پہلے، تصدیق کریں کہ کاروبار قانونی طور پر رجسٹرڈ ہے۔",
    stat_businesses_label: "FBR ڈیٹا بیس میں رجسٹرڈ کاروبار",
    scan_receipt: "رسید اسکین کریں",
    all_business_types: "کاروبار کی تمام اقسام",
    fbr_atl_database: "FBR ATL ڈیٹا بیس",
    name_ntn_search: "نام اور این ٹی این تلاش",
    receipt_scanner: "رسید اسکینر",
    always_free: "ہمیشہ مفت",
    theme_light: "روشنی",
    theme_dark: "اندھیرا",
    lang_toggle: "English",
    footer_desc:
      "پاکستان کا کنزیومر ٹیکس ویریفیکیشن ٹول۔ صرف معلوماتی۔ ہمیشہ سرکاری حکام سے تصدیق کریں۔",
    footer_copy:
      "FBR، SRB، PRA، KPRA، BRA یا کسی بھی سرکاری ادارے سے وابستہ نہیں ہے۔",
    search_title: "FBR ڈیٹا بیس تلاش کریں",
    search_sub:
      "کسی بھی کاروبار کو براہ راست FBR کی ایکٹو ٹیکس پیئر لسٹ کے خلاف تلاش کریں — NTN، SNTN، یا کاروباری نام کے ذریعے۔",
    records_loaded: "ریکارڈز لوڈ کیے گئے۔",
    sntn_label: "SNTN — سندھ سیلز ٹیکس نمبر",
    ntn_label: "NTN — نیشنل ٹیکس نمبر",
    search_placeholder: "مثال کے طور پر 7221683-2 یا S7221683-2 یا 7221683",
    try_example: "ایک مثال آزمائیں",
    search_fbr: "FBR ڈیٹا بیس تلاش کریں",
    found_in_db: "FBR ڈیٹا بیس میں مل گیا",
    not_found_in_db: "FBR ڈیٹا بیس میں نہیں ملا",
    business_name_label: "کاروبار / ٹیکس دہندہ کا نام",
    name_search_placeholder: "مثال کے طور پر حافظ جی یا کراچی فوڈز",
    name_search_hint:
      "ٹیکس دہندہ کے نام اور کاروباری نام دونوں میں تلاش کرتا ہے · کم از کم 2 حروف",
    how_search_works: "تلاش کیسے کام کرتی ہے",
    disclaimer_text:
      "صرف معلوماتی تصدیق — قانونی نتائج نہیں ہیں۔ ہمیشہ آفیشل FBR / صوبائی حکام سے تصدیق کریں۔",
    taxpayer_name: "ٹیکس دہندہ کا نام",
    business_name: "کاروباری نام",
    atl_status: "ATL کی حیثیت",
    active: "فعال",
    status_registered: "✅ رجسٹرڈ ہونے کا امکان ہے",
    status_partial: "⚠️ جزوی / غیر یقینی",
    status_weak: "🔶 صرف کمزور سگنلز",
    status_not_found: "❌ کوئی درست سگنل نہیں ملا",
    verify_on_srb: "SRB پر تصدیق کریں",
    verify_on_fbr: "FBR پر تصدیق کریں",
    result_note:
      "اسکور FBR ڈیٹا بیس کی تلاش، STRN فارمیٹ، اور QR تجزیہ پر مبنی ہے۔ قانونی یقین کے لیے ہمیشہ آفیشل پورٹلز کے ذریعے تصدیق کریں۔",
    supported_business_types: "تائید شدہ کاروبار کی اقسام",
    tax_rules: "کاروبار کی قسم کے لحاظ سے ٹیکس کے قوانین",
    official_authorities: "سرکاری ٹیکس حکام",
    how_title_1: "ڈیٹا بیس تلاش کریں",
    how_text_1:
      "{count} رجسٹرڈ کاروباروں کو NTN، SNTN، یا کاروباری نام کے ذریعے براہ راست FBR کی ایکٹو ٹیکس پیئر لسٹ سے تلاش کریں۔",
    how_title_2: "کسی بھی فارمیٹ میں لکھیں",
    how_text_2:
      "NTN (7221683-2)، SNTN (S7221683-2)، یا صرف ہندسے (7221683) لکھیں۔ ہم خود بخود ان کو درست کر لیں گے۔",
    how_title_3: "رسید اسکین کریں",
    how_text_3:
      "کسی بھی بل کی تصویر اپ لوڈ کریں۔ ہم FBR POS QR کوڈز کا پتہ لگاتے ہیں اور OCR کے ذریعے NTN/STRN نکالتے ہیں۔",
    how_title_4: "FBR پر تصدیق کریں",
    how_text_4:
      "ہم براہ راست FBR کے آفیشل پورٹل سے لنک کرتے ہیں — تصدیق کے لیے صرف ایک کلک کریں۔",
    business: "کاروبار",
    tax_type: "ٹیکس کی قسم",
    authority: "اتھارٹی",
    rate: "شرح",
    business_type: "کاروبار کی قسم",
    tax_authority: "ٹیکس اتھارٹی",
    typical_rate: "عام شرح",
    note: "نوٹ",
    bt_restaurant: "ریسٹورنٹ / کیفے",
    bt_restaurant_note:
      "صوبائی اتھارٹی (SRB/PRA/KPRA) کے ذریعے سروس ٹیکس۔ ٹیر-1 کے لیے FBR POS لازمی ہے۔",
    bt_restaurant_rates: "13-16٪ سروس ٹیکس",
    bt_retail: "شاپنگ / ریٹیل اسٹور",
    bt_retail_note:
      "فروخت شدہ سامان پر جی ایس ٹی۔ ٹیر-1 ریٹیلرز کے پاس FBR سے مربوط POS ہونا ضروری ہے۔",
    bt_retail_rates: "17٪ جی ایس ٹی معیار",
    bt_pharmacy: "فارمیسی / میڈیکل اسٹور",
    bt_pharmacy_note:
      "بہت سی ادویات زیرو ریٹیڈ یا مستثنیٰ ہیں۔ جی ایس ٹی صرف غیر مستثنیٰ اشیاء پر لاگو ہوتا ہے۔",
    bt_pharmacy_rates: "0-17٪ جی ایس ٹی (مختلف ہے)",
    bt_supermarket: "سپر مارکیٹ / گروسری",
    bt_supermarket_note:
      "پیک شدہ سامان پر جی ایس ٹی۔ تازہ پیداوار اور ضروری اشیاء اکثر زیرو ریٹیڈ یا مستثنیٰ ہوتی ہیں۔",
    bt_supermarket_rates: "17٪ جی ایس ٹی (پیک شدہ اشیاء)",
    bt_hotel: "ہوٹل / گیسٹ ہاؤس",
    bt_hotel_note:
      "رہائش پر سروس ٹیکس۔ لگژری خدمات پر فیڈرل ایکسائز ڈیوٹی (FED) بھی لاگو ہو سکتی ہے۔",
    bt_hotel_rates: "16٪ + ممکنہ FED",
    bt_salon: "سیلون / سپا / بیوٹی",
    bt_salon_note:
      "بیوٹی/گرومنگ سروسز پر سروس ٹیکس۔ چھوٹے سیلون اکثر رجسٹریشن کی حد سے نیچے ہوتے ہیں۔",
    bt_salon_rates: "13-16٪ سروس ٹیکس",
    bt_electronics: "الیکٹرانکس اسٹور",
    bt_electronics_note:
      "الیکٹرانکس پر 17٪ جی ایس ٹی معیار۔ ود ہولڈنگ ٹیکس بھی لاگو ہو سکتا ہے۔ FBR POS چیک کریں۔",
    bt_electronics_rates: "17٪ جی ایس ٹی",
    bt_fuel: "پیٹرول اسٹیشن",
    bt_fuel_note:
      "پیٹرولیم لیوی اور جی ایس ٹی لاگو ہوتے ہیں۔ بڑے آؤٹ لیٹس کے لیے POS انضمام لازمی ہے۔",
    bt_fuel_rates: "جی ایس ٹی + پیٹرولیم لیوی",
    bt_telecom: "ٹیلی کام / موبائل شاپ",
    bt_telecom_note:
      "سم کارڈز اور آلات پر جی ایس ٹی۔ سروس چارجز سروس ٹیکس کے تابع ہیں۔",
    bt_telecom_rates: "17-19.5٪ جی ایس ٹی",
    bt_clinic: "کلینک / ہسپتال",
    bt_clinic_note:
      "طبی خدمات عام طور پر جی ایس ٹی سے مستثنیٰ ہیں۔ تشخیصی لیبز ٹیکس کے قابل ہو سکتی ہیں۔",
    bt_education: "اسکول / ٹیوشن سینٹر",
    bt_education_note:
      "تعلیمی خدمات عام طور پر مستثنیٰ ہیں۔ کمرشل کوچنگ سینٹرز ٹیکس کے قابل ہو سکتے ہیں۔",
    bt_other: "دیگر کاروبار",
    bt_other_note:
      "متعلقہ رہنمائی کے لیے قریب ترین زمرہ منتخب کریں، یا براہ راست تصدیق کے لیے NTN/STRN درج کریں۔",
    bt_varies: "مختلف ہے",
    bt_exempt: "زیادہ تر مستثنیٰ",
    bt_provincial: "صوبائی (SRB/PRA/KPRA/BRA)",
    bt_fbr: "FBR (وفاقی)",
    bt_provincial_fbr: "صوبائی + FBR",
    bt_fbr_provincial: "FBR / صوبائی",
    auth_fbr_full: "فیڈرل بورڈ آف ریونیو",
    auth_srb_full: "سندھ ریونیو بورڈ",
    auth_pra_full: "پنجاب ریونیو اتھارٹی",
    auth_kpra_full: "کے پی کے ریونیو اتھارٹی",
    auth_bra_full: "بلوچستان ریونیو اتھارٹی",
    region_federal: "وفاقی",
    region_sindh: "سندھ",
    region_punjab: "پنجاب",
    region_kpk: "کے پی کے",
    region_balochistan: "بلوچستان",
    about_title: "TaxVerifypk.com کے بارے میں",
    about_p1:
      "TaxVerifypk.com ایک آزاد صارف پلیٹ فارم ہے جو پاکستانیوں کو تمام قسم کے کاروباروں میں ٹیکس رجسٹریشن کی تصدیق کرنے میں مدد کرتا ہے۔",
    about_h1: "ہم کیا کرتے ہیں",
    about_p2:
      "ہم NTN اور SNTN نمبروں کو براہ راست FBR کی ایکٹو ٹیکس پیئر لسٹ کے ساتھ ملاتے ہیں — جو کہ تمام رجسٹرڈ ٹیکس دہندگان کا ڈیٹا بیس ہے۔ SNTN (سندھ کی رسیدیں جو S سے شروع ہوتی ہیں) خود بخود ہٹا دی جاتی ہیں اور تلاش کی جاتی ہیں۔ ہم jsQR کے ذریعے رسید کی تصاویر میں FBR POS QR کوڈز کا بھی پتہ لگاتے ہیں اور Tesseract.js OCR کے ذریعے رجسٹریشن نمبر نکالتے ہیں۔",
    about_h2: "چیک ڈیجیٹ پالیسی",
    about_p3:
      "اب ہم چیک ڈیجیٹ کی عدم مطابقت کی بنیاد پر NTNs کو مسترد نہیں کرتے ہیں۔ जैसा کہ حقیقی دنیا کے ٹیسٹنگ کے ذریعے تصدیق شدہ ہے، FBR کا اپنا پورٹل چیک ڈیجیٹ کو نظر انداز کرتا ہے اور 7 ہندسوں کی بنیاد پر میچ کرتا ہے۔ ہم عدم مطابقت کو ممکنہ پرنٹنگ کی غلطی کے طور پر نشان زد کرتے ہیں لیکن پھر بھی ڈیٹا بیس میں کاروبار تلاش کرتے ہیں۔",
    about_h3: "پرائیویسی",
    about_p4:
      "رسید کی تمام اسکیننگ مکمل طور پر آپ کے براؤزر میں ہوتی ہے۔ کچھ بھی کسی سرور کو نہیں بھیجا جاتا ہے۔ کوئی ڈیٹا محفوظ نہیں کیا جاتا ہے۔",
    msg_sent: "پیغام بھیج دیا گیا",
    msg_sent_sub: "ہم 2-3 کاروباری دنوں میں جواب دیں گے۔",
    name: "نام",
    full_name: "پورا نام",
    email: "ای میل",
    email_placeholder: "your@email.com",
    subject: "مضمون",
    sub_1: "کسی مشکوک کاروبار کی اطلاع دیں",
    sub_2: "ڈیٹا کی درستگی",
    sub_3: "عام انکوائری",
    sub_4: "میڈیا / پریس",
    sub_5: "شراکت داری",
    message: "پیغام",
    message_placeholder: "آپ کا پیغام…",
    send_message: "پیغام بھیجیں",
    karachi_pakistan: "کراچی، پاکستان",
    verify_sub:
      "FBR کے ڈیٹا بیس کے خلاف کسی بھی رجسٹریشن نمبر کو چیک کریں اور براہ راست تصدیق کا لنک حاصل کریں۔ SNTN (سندھ کی رسیدیں) خود بخود ہینڈل ہو جاتی ہیں۔",
    and_or: "اور / یا",
    sntn_hint:
      "SRB SNTNs کو S + NTN کے طور پر جاری کرتا ہے — مثال کے طور پر S7221683-2۔ ہم S کو ہٹا دیتے ہیں اور FBR میں خود بخود تلاش کرتے ہیں۔",
    upload_title: "کسی بھی کاروباری رسید کو اسکین کریں",
    upload_sub:
      "کسی بھی بل کی تصویر اپ لوڈ کریں۔ ہم QR کوڈز کا پتہ لگائیں گے، OCR کے ذریعے NTN/STRN نکالیں گے، اور FBR کے ڈیٹا بیس میں تلاش کریں گے۔",
    all_guides: "تمام گائیڈز",
    guides_sub:
      "پاکستان میں تمام کاروباری اقسام کے ٹیکسوں کے بارے میں وہ سب کچھ جو آپ کو جاننے کی ضرورت ہے — اکاؤنٹنٹس کے لیے نہیں، بلکہ صارفین کے لیے لکھی گئی ہے۔",
    search_by_ntn: "NTN / SNTN کے ذریعے تلاش کریں",
    search_by_name: "کاروباری نام سے تلاش کریں",
    no_matches_found: "کوئی نتیجہ نہیں ملا",
    no_match_msg: "FBR ڈیٹا بیس میں \"{query}\" سے ملتا جلتا کوئی کاروبار نہیں ملا۔",
    not_found_msg: "FBR ایکٹو ٹیکس پیئر لسٹ میں نہیں ملا۔",
  },
};

export const GUIDES = [
  {
    id: "gst-overview",
    icon: "🇵🇰",
    title: "Pakistan's Tax System Overview",
    summary:
      "How GST, service tax, and FED work across different business types.",
    body: `Pakistan has a dual tax structure where the federal government (FBR) levies GST on goods, while provinces levy service tax on services through their own revenue authorities.\n\n**Federal GST (FBR)**\n\nThe Federal Board of Revenue administers the Sales Tax Act, 1990. GST at 17% applies to most goods sold by registered businesses. Businesses with annual turnover above the registration threshold must register with FBR.\n\n**Provincial Service Tax**\n\nRestaurant services, salons, hotels, and other service businesses fall under provincial jurisdiction. Sindh has the SRB, Punjab has the PRA, KPK has the KPRA, and Balochistan has the BRA. Each sets its own rate (typically 13–16%).\n\n**FBR POS Integration**\n\nSince 2019, all Tier-1 retailers must integrate their billing systems with FBR's POS network. Every bill must carry a unique FBR QR code — the strongest on-bill signal of legitimate registration.`,
  },
  {
    id: "by-business",
    icon: "🏪",
    title: "Tax Rules by Business Type",
    summary:
      "Specific rules for restaurants, retail, pharmacies, hotels, salons, and more.",
    body: `Different business types have different tax obligations in Pakistan.\n\n**Restaurants & Cafés**\n\nService tax via provincial authority. Karachi restaurants: SRB (SNTN required). Lahore: PRA. Peshawar: KPRA. The rate is 13–16%. FBR POS QR mandatory for Tier-1.\n\n**Retail / Shopping Stores**\n\nFederal GST at 17% on goods. Tier-1 retailers must have FBR-integrated POS and print a QR code.\n\n**Pharmacies & Medical Stores**\n\nMany medicines are zero-rated — meaning no GST should be charged. Always check whether the items charged tax are genuinely taxable.\n\n**Hotels & Guesthouses**\n\nService tax on accommodation (provincial) plus possible Federal Excise Duty (FED) on luxury services.\n\n**Salons & Spas**\n\nService tax via provincial authority. Many small salons fall below the registration threshold and should not charge tax.`,
  },
  {
    id: "ntn-guide",
    icon: "🔢",
    title: "Understanding NTN & SNTN Numbers",
    summary:
      "What these numbers mean, how to read them, and how our database lookup works.",
    body: `The National Tax Number (NTN) is the primary identifier for registered taxpayers in Pakistan.\n\n**NTN Format**\n\nAn NTN is XXXXXXX-X — seven digits, a hyphen, one check digit. FBR's own search portal actually ignores the check digit and matches on the 7-digit base, which is why a wrong check digit on a receipt may still belong to a real business.\n\n**SNTN — Sindh's Format**\n\nThe SRB issues an SNTN (Sindh Sales Tax Registration Number) to every Sindh service provider. It is formed by prefixing "S" to the NTN. Our app strips the S automatically before searching FBR's database.\n\n**Database Lookup vs. Check Digit**\n\nThis app now looks up NTNs directly against FBR's Active Taxpayer List. A match means the business is confirmed in the database. A check digit mismatch is flagged as a likely printing error but does not prevent the lookup.\n\n**Where to Find These on Your Bill**\n\nLook in the bill's header or footer for NTN:, STRN:, GST Reg No:, or SNTN:. For Sindh restaurants and service providers, look for the S-prefixed number.`,
  },
  {
    id: "qr-guide",
    icon: "📱",
    title: "FBR POS QR Codes Explained",
    summary:
      "What the QR code on your bill means and why its presence matters.",
    body: `Since 2019, FBR has required all Tier-1 retailers and restaurants to integrate with their POS network.\n\n**What's in the QR Code**\n\nThe QR encodes a URL to FBR's verification portal along with the invoice number, POS terminal ID, date, and amount. Scanning it takes you directly to FBR where you can confirm the invoice exists.\n\n**Our Detection**\n\nWhen you upload a bill image, we use jsQR to scan for all QR codes. We check whether the decoded URL points to e.fbr.gov.pk or a recognised provincial authority.\n\n**Absence of a QR**\n\nA missing QR is a warning signal — but not automatic proof of fraud. Smaller businesses in the same categories may not yet be integrated. Always cross-check with the NTN database lookup.`,
  },
  {
    id: "consumer-rights",
    icon: "⚖️",
    title: "Your Consumer Rights",
    summary:
      "What you can demand from any business charging tax, and how to report fraud.",
    body: `As a Pakistani consumer, you have clear rights regarding tax charges on any bill.\n\n**The Right to a Proper Invoice**\n\nAny registered business charging tax must issue a proper tax invoice showing their NTN/SNTN and registration number, the tax rate applied, and a unique invoice serial number.\n\n**The Right to Question the Charge**\n\nIf a business cannot produce a valid registration number found in FBR's database, they may not be entitled to charge tax.\n\n**Reporting Channels**\n\nFBR Helpline: 051-111-772-772. SRB (Sindh): srb.gos.pk. PRA (Punjab): pra.punjab.gov.pk. KPRA (KPK): kpra.gov.pk.\n\n**Tax Asaan App**\n\nFBR's own mobile app allows QR scanning of POS receipts and enrolls you in FBR's prize scheme for consumers who report unregistered businesses.`,
  },
];
